import { IdPersistence } from "../constants/IdPersistence";
import { utilPersistence } from "../utils/utilPersistence";
export var selectVisitedQuests = function () {
    var completedQuestIntroIds = utilPersistence.getValue(IdPersistence.QuestIntro, { visitedQuestIntroIds: new Set() });
    return completedQuestIntroIds.visitedQuestIntroIds
        ? new Set(completedQuestIntroIds.visitedQuestIntroIds)
        : new Set();
};
export var selectIsQuestVisited = function (questId) {
    var visitedQuestIntroIds = selectVisitedQuests();
    return visitedQuestIntroIds.has(questId);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectVisitedQuests.ts
// module id = 567
// module chunks = 3